import React, { useEffect, useRef } from "react";
import Slider from "../../common/Slider";
import { Box, Text, Flex } from "@radix-ui/themes";
import Button from "../../common/Button";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import {
  animateServicesHeader,
  animateServiceCards,
} from "../../../utils/animations";

const Services = ({ slides }) => {
  const navigate = useNavigate();
  const servicesRef = useRef(null);
  const headerRef = useRef(null);

  // Animation for header
  useEffect(() => {
    return animateServicesHeader(headerRef, slides);
  }, [slides]);

  // Animation for service cards
  useEffect(() => {
    return animateServiceCards(servicesRef, slides);
  }, [slides]);

  const renderServiceCard = (service, idx) => (
    <Box className={styles.serviceCard}>
      <Flex direction="column" style={{ width: "100%", height: "100%" }}>
        {service.image && (
          <img
            src={service.image}
            alt={service.title}
            className={styles.serviceImage}
          />
        )}
        <div className={styles.serviceContent}>
          <div>
            <Flex
              direction="column"
              align="center"
              className={styles.serviceHeader}
            >
              <Text className={styles.serviceTitle}>
                {service.title}
              </Text>
              <Text className={styles.serviceDescription}>
                {service.description}
              </Text>
            </Flex>
            {service.services && service.services.length > 0 && (
              <div className={styles.servicesList}>
                {service.services.slice(0, 5).map((item, subIdx) => (
                  <Text key={subIdx} className={styles.serviceItem}>
                    {item.name}
                  </Text>
                ))}
                {service.services.length > 7 && (
                  <Text className={styles.serviceItem}>
                    {service.services[7].name} ...
                  </Text>
                )}
              </div>
            )}
          </div>
          <div>
            {service.url && (
              <Box className={styles.serviceButtonContainer}>
                <Button
                  variant="normal"
                  size="2"
                  className={styles.serviceButton}
                  onClick={() => navigate("/services", { state: { serviceId: idx } })}
                  backgroundColor="var(--color-primary)"
                  textColor="var(--color-secondary)"
                >
                  Read More
                </Button>
              </Box>
            )}
          </div>
        </div>
      </Flex>
    </Box>
  );

  return (
    <Box ref={servicesRef} className={styles.services}>
      <Flex ref={headerRef} direction="column" align="center" gap="3" className={styles.header}>
        <Text size="8" className={styles.title}>
          Services
        </Text>
        <Text className={styles.subtitle}>
          Redefining skin and body rejuvenation.
        </Text>
      </Flex>
      <Slider 
        items={slides} 
        renderSlide={renderServiceCard}
        slidesPerView={4}
        spaceBetween={20}
        speed={10000}
        autoplay={true}
        mobileGrid={true}
      />
    </Box>
  );
};

export default Services;
